import { useEffect } from 'react';


export default function MemoModal({
  isMemoModalOpen,
  setIsMemoModalOpen,
  memoSaveMode,
  setMemoSaveMode,
  memoHint,
  setMemoHint,
  handleRunMemoization,
  isSummarizing,
  existingSummaryNote,
}) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && !isSummarizing) {
        setIsMemoModalOpen(false);
      }
    };
    if (isMemoModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isMemoModalOpen, isSummarizing, setIsMemoModalOpen]);

  if (!isMemoModalOpen) return null;

  return (
    <div className="fixed inset-0 z-[160] bg-black/60 flex items-center justify-center p-4" onClick={(e) => { if (e.target === e.currentTarget && !isSummarizing) setIsMemoModalOpen(false); }}>
      <div className="w-full max-w-md bg-gray-800 border border-gray-700 rounded-lg shadow-xl p-4 space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-white">Noteまとめ</h2>
          <button
            aria-label="閉じる"
            type="button"
            onClick={() => !isSummarizing && setIsMemoModalOpen(false)}
            disabled={isSummarizing}
            className="text-gray-400 hover:text-white text-xl leading-none disabled:opacity-30 disabled:cursor-not-allowed transition-opacity"
          >
            ×
          </button>
        </div>

        <p className="text-sm text-gray-400">
          Sinkログの会話を整理してNoteを作成します。
        </p>

        <div className="space-y-4">
          <div className="space-y-2">
            <div className="flex bg-gray-900 border border-gray-700 rounded p-1">
              <button
                type="button"
                onClick={() => !isSummarizing && setMemoSaveMode('new')}
                disabled={isSummarizing}
                className={`flex-1 py-1.5 rounded text-xs font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed ${memoSaveMode === 'new' ? 'bg-purple-600 text-white shadow' : 'text-gray-400 hover:text-gray-300'}`}
              >
                新規作成
              </button>
              <button
                type="button"
                onClick={() => !isSummarizing && setMemoSaveMode('overwrite')}
                disabled={!existingSummaryNote || isSummarizing}
                className={`flex-1 py-1.5 rounded text-xs font-bold transition-all disabled:opacity-30 disabled:cursor-not-allowed ${memoSaveMode === 'overwrite' ? 'bg-purple-600 text-white shadow' : 'text-gray-400 hover:text-gray-300'}`}
              >
                上書き更新
              </button>
            </div>
            {memoSaveMode === 'overwrite' && existingSummaryNote && (
              <div className="bg-purple-950/20 border border-purple-500/30 rounded-lg p-3">
                <p className="text-[10px] font-black text-purple-400 uppercase tracking-widest mb-1">上書き対象のNote</p>
                <p className="text-xs text-white font-bold truncate">📄 {existingSummaryNote.title}</p>
              </div>
            )}
            {!existingSummaryNote && (
              <p className="text-[10px] text-gray-500 italic">※ このSinkに関連付けられたNoteがないため、上書きはできません。</p>
            )}
          </div>

          <div className="space-y-1">
            <label htmlFor="memo-hint" className="block text-xs font-medium text-gray-400">抽出の指示・キーワード（任意）</label>
            <textarea
              id="memo-hint"
              value={memoHint}
              onChange={(e) => setMemoHint(e.target.value)}
              disabled={isSummarizing}
              placeholder="例：OOに関する議論だけをまとめる、箇条書きにする、等"
              className="w-full bg-gray-700 border border-gray-600 text-white p-2 rounded text-sm focus:outline-none focus:border-purple-500 h-24 disabled:opacity-50 disabled:cursor-not-allowed"
            />
          </div>
        </div>

        <div className="flex gap-2 pt-2">
          <button
            type="button"
            onClick={() => !isSummarizing && setIsMemoModalOpen(false)}
            disabled={isSummarizing}
            className="flex-1 bg-gray-700 text-white py-2 rounded text-sm font-bold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            キャンセル
          </button>
          <button onClick={handleRunMemoization} disabled={isSummarizing} className="flex-1 bg-purple-600 hover:bg-purple-500 disabled:bg-gray-700 text-white py-2 rounded text-sm font-bold shadow-lg shadow-purple-900/20 transition-all active:scale-95 flex items-center justify-center gap-2">
            {isSummarizing && (
              <svg className="animate-spin h-3.5 w-3.5 text-white" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            )}
            {isSummarizing ? '作成中...' : 'Noteを作成'}
          </button>
        </div>
      </div>
    </div>
  );
}
